import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=30e399ea&"
import script from "./Multiple.vue?vue&type=script&lang=js&"
export * from "./Multiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e399ea')) {
      api.createRecord('30e399ea', component.options)
    } else {
      api.reload('30e399ea', component.options)
    }
    module.hot.accept("./Multiple.vue?vue&type=template&id=30e399ea&", function () {
      api.rerender('30e399ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/QuestionItem/Multiple.vue"
export default component.exports